<div class="billing-overlay" (click)="onBackdropClick()">
  <div class="billing-modal" (click)="$event.stopPropagation()">
    <div class="billing-header">
      <div>
        <h2 class="billing-title">{{ title }}</h2>
        <p class="billing-subtitle">{{ subtitle }}</p>
      </div>
      <button type="button" class="billing-close-btn" (click)="closed.emit()" [disabled]="isSaving">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <form class="billing-form" (ngSubmit)="onSubmit()" novalidate>
      <div class="billing-type-row">
        <span class="billing-label">Billing type</span>
        <div class="billing-type-options">
          <label class="billing-type-option" [class.active]="form.billing_type === 'individual'">
            <input type="radio" name="billing_type" value="individual" [ngModel]="form.billing_type" (ngModelChange)="onBillingTypeChange($event)">
            Individual
          </label>
          <label class="billing-type-option" [class.active]="form.billing_type === 'business'">
            <input type="radio" name="billing_type" value="business" [ngModel]="form.billing_type" (ngModelChange)="onBillingTypeChange($event)">
            Business
          </label>
        </div>
      </div>

      <div class="billing-grid">
        <label class="billing-field">
          <span class="billing-label">Full name *</span>
          <input type="text" [(ngModel)]="form.name" name="name" maxlength="150" placeholder="Name as on invoice">
          <small class="billing-error" *ngIf="errors['name']">{{ errors['name'] }}</small>
        </label>

        <label class="billing-field" *ngIf="isBusiness">
          <span class="billing-label">Company name *</span>
          <input type="text" [(ngModel)]="form.company_name" name="company_name" maxlength="200" placeholder="Registered business name">
          <small class="billing-error" *ngIf="errors['company_name']">{{ errors['company_name'] }}</small>
        </label>

        <label class="billing-field">
          <span class="billing-label">Email *</span>
          <input type="email" [(ngModel)]="form.email" name="email" maxlength="255" placeholder="billing@example.com">
          <small class="billing-error" *ngIf="errors['email']">{{ errors['email'] }}</small>
        </label>

        <label class="billing-field">
          <span class="billing-label">Phone *</span>
          <input type="text" [(ngModel)]="form.phone" name="phone" maxlength="15" placeholder="10-digit mobile number">
          <small class="billing-error" *ngIf="errors['phone']">{{ errors['phone'] }}</small>
        </label>

        <label class="billing-field billing-field-full">
          <span class="billing-label">Address line 1 *</span>
          <input type="text" [(ngModel)]="form.address_line1" name="address_line1" maxlength="255" placeholder="Street address">
          <small class="billing-error" *ngIf="errors['address_line1']">{{ errors['address_line1'] }}</small>
        </label>

        <label class="billing-field billing-field-full">
          <span class="billing-label">Address line 2</span>
          <input type="text" [(ngModel)]="form.address_line2" name="address_line2" maxlength="255" placeholder="Landmark, area (optional)">
        </label>

        <label class="billing-field">
          <span class="billing-label">City *</span>
          <input type="text" [(ngModel)]="form.city" name="city" maxlength="100" placeholder="City">
          <small class="billing-error" *ngIf="errors['city']">{{ errors['city'] }}</small>
        </label>

        <label class="billing-field">
          <span class="billing-label">State *</span>
          <select [(ngModel)]="form.state" name="state">
            <option value="">Select state</option>
            <option *ngFor="let state of states" [value]="state.name">{{ state.name }}</option>
          </select>
          <small class="billing-error" *ngIf="errors['state']">{{ errors['state'] }}</small>
        </label>

        <label class="billing-field">
          <span class="billing-label">PIN code *</span>
          <input type="text" [(ngModel)]="form.pincode" name="pincode" maxlength="6" placeholder="6-digit PIN">
          <small class="billing-error" *ngIf="errors['pincode']">{{ errors['pincode'] }}</small>
        </label>

        <label class="billing-field">
          <span class="billing-label">{{ isBusiness ? 'GSTIN *' : 'GSTIN (optional)' }}</span>
          <input type="text" [(ngModel)]="form.gstin" name="gstin" maxlength="15" placeholder="15-character GSTIN" (input)="form.gstin = (form.gstin || '').toUpperCase()">
          <small class="billing-error" *ngIf="errors['gstin']">{{ errors['gstin'] }}</small>
        </label>
      </div>

      <div class="billing-actions">
        <button type="button" class="billing-cancel-btn" (click)="closed.emit()" [disabled]="isSaving">Cancel</button>
        <button type="submit" class="billing-save-btn" [disabled]="isSaving">
          {{ isSaving ? 'Saving...' : 'Save billing details' }}
        </button>
      </div>
    </form>
  </div>
</div>
